import React, {useContext, useEffect} from 'react'
import {OfferContext} from "../../../context/OfferContext";
import {Form, Select} from "antd";


const currency = {
    'EUR': 'EUR',
    'USD': 'USD',
    'TRY': 'TRY'
}
const {Option} = Select

const OfferCreateCurrency = ({rowIndex, record}) => {
    const [form] = Form.useForm()
    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    useEffect(() => {
        if (record.data)
            form.setFieldsValue({
                [`${rowIndex}-currencySelect`]: record.data.currency
            })

    })

    const handleCurrencyChange = (value) => {
        let mockContext = [...materials]
        mockContext[rowIndex].data.currency = value
        setMaterials(mockContext)
    }

    return (
        <React.Fragment>

            <Form form={form}>
                <Form.Item name={`${rowIndex}-currencySelect`}>
                    <Select
                        disabled={!record.data}
                        onChange={handleCurrencyChange}
                    >
                        {
                            Object.keys(currency).map(key => <Option key={key} value={key}>{key}</Option>)
                        }
                    </Select>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferCreateCurrency